import axios from 'axios';
import {
  SOCIAL_COUPON_REQUEST,
  SOCIAL_COUPON_SUCCESS,
  SOCIAL_COUPON_FAILURE,

  SHARE_COUPON_SUCCESS,
} from 'Store/constants';
import { getChannel } from 'Utils/channel';
import { getEventScores } from 'Store/actions';
import errorMessage from 'Store/actions/errorMessage';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getExternalShareCouponId = (couponId = '', socialMedia = '', source = '')  => async dispatch => {
  try {

    let requestData = {
      couponId,
      socialMedia,
      type: source
    };

    if (source === 'SPORTOTO') {
      requestData = {
        couponId,
        type: source
      };
    }


    const res = await axios({
      url: `${API_GATEWAY}/coupon-share`,
      method: 'post',
      data: requestData,
      headers: {
        channel: getChannel()
      }
    });

    dispatch({ type: SHARE_COUPON_SUCCESS });

    if (res.data) {
      return res.data?.externalCouponId;
    }

  } catch (e) {
    //console.log(e);
  }

};

export const getSocialCoupon = externalCouponId => async dispatch => {
  try {

    dispatch({
      type: SOCIAL_COUPON_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/coupon-share/coupons/${externalCouponId}`,
      method: 'get',
      headers: {
        channel: getChannel()
      }
    });

    dispatch({
      type: SOCIAL_COUPON_SUCCESS,
      payload: res.data
    });

    dispatch(getEventScores(res.data.couponColumns));

  } catch (e) {

    dispatch({
      type: SOCIAL_COUPON_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};
